"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakerRecognitionConfig = void 0;
const Exports_js_1 = require("./Exports.js");
class SpeakerRecognitionConfig {
    constructor(context, parameters) {
        this.privContext = context ? context : new Exports_js_1.Context(null);
        this.privParameters = parameters;
    }
    get parameters() {
        return this.privParameters;
    }
    get Context() {
        return this.privContext;
    }
}
exports.SpeakerRecognitionConfig = SpeakerRecognitionConfig;

//# sourceMappingURL=SpeakerRecognitionConfig.js.map
